import { datasMapStatus as constants } from "../constants";

const initialState = [];

export default function(datasMapsStatus = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case constants.RETRIEVE_DATAS_MAP_STATUS:
      return payload;
    default:
      return datasMapsStatus;
  }
}
